import { render, staticRenderFns } from "./ResumeInsurance.vue?vue&type=template&id=11aba921"
import script from "./ResumeInsurance.vue?vue&type=script&lang=js"
export * from "./ResumeInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports